import { useAuth } from "hooks/useAuth";
import { Link } from "react-router-dom";
import { AdminList } from "types/User";

export function OptionManageTemplates() {
    const { user } = useAuth();

    if (user == null || !AdminList.includes(user.name)) {
        return (<div></div>);
    } else {
        return (
            <tr>
                <td>Gerenciar templates</td>
                <td><Link to={"/templates"} >Acessar</Link></td>
            </tr>
        );
    }
}
